module.exports = __webpack_public_path__ + "static/media/history-empty.e67e5394.png";